// import css from "./popUp.module.css";
// import React from "react";

// const PopSp = React.forwardRef(({ onClick }, ref) => {
//   return (
//     <div className={css.popSPWrap} ref={ref} onClick={onClick}>
//       <p className={css.mainPopP}>
//         Для організаторів СП (спільних покупок), корпоративних замовлень,
//         покупок для школи/садочку пропонуємо індивідуальні умови співпраці.
//         Реєструйтеся на сайті зі статусом "СП" та використовуйте гуртову форму
//         замовлення на сторінці "Прайс для гурту". Для узгодження деталей
//         звертайтеся:
//         <a href="mailto:sales@chasmaistriv.com.ua">sales@chasmaistriv.com.ua</a>
//       </p>
//     </div>
//   );
// });

// export default PopSp;

// src/components/PopSp.jsx
import React from "react";
import css from "./popUp.module.css";
import { db } from "../../firebase"; // скоригуй шлях під свій
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "sp_corporate_group_class"; // popups/sp_corporate_group_class

const PopSp = React.forwardRef(({ onClick, className }, ref) => {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      setHtml(snap.exists() ? snap.data()?.contentHtml || "" : "");
    });
    return () => unsub();
  }, []);

  return (
    <div className={`${css.popSPWrap} `} ref={ref} onClick={onClick}>
      <div
        className={`${css.mainPopP} `}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
});

export default PopSp;
